import React, { useEffect, useState } from 'react'
import { Button, Select } from 'antd'
import { downloadFile } from 'utils/importExport/utils/export'
import { buildTemplateCsv } from '../templateForm'
import styles from './style.module.scss'

// 템플릿 양식 프리셋의 양식 다운로드 영역(spec D3): 템플릿을 고르고 그 양식(헤더 한 줄 CSV)을 내려받는다
// 카드 목록 안, 템플릿 양식 카드 바로 아래에 렌더된다(spec D19) — 제목은 두지 않는다(카드 이름이 제목)
const TemplateDownloadSection = ({ templateCatalog, t }) => {
  // 다운로드할 템플릿은 이 컴포넌트의 state 다 — 가져오기 선택(리듀서 selectedTemplateId)과 묶으면 파일 판별이
  // 다운로드 목록을 바꾼다(spec D6)
  const [downloadTemplateId, setDownloadTemplateId] = useState(null)

  // 카탈로그가 준비되면 대부분의 사용자가 바로 누르도록 Web Login 을 기본 선택한다(없으면 첫 항목). 응답 name 은
  // 항상 영문 title 이라 로케일과 무관하게 비교할 수 있다(frontend wiki template-display-names §3)
  useEffect(() => {
    if (downloadTemplateId != null || templateCatalog.status !== 'success') return
    const defaultItem =
      templateCatalog.items.find((item) => item.name === 'Web Login') ?? templateCatalog.items[0]
    if (defaultItem) setDownloadTemplateId(defaultItem.id)
  }, [downloadTemplateId, templateCatalog])

  const downloadTemplate =
    templateCatalog.items.find((item) => item.id === downloadTemplateId) || null

  const handleDownload = () => {
    if (!downloadTemplate) return
    downloadFile(
      buildTemplateCsv(downloadTemplate.schema),
      `${downloadTemplate.displayName}_${t('record.import.v2.template.fileNameSuffix')}.csv`,
      'text/csv;charset=utf-8',
    )
  }

  return (
    <div className={[styles.templateForm, styles.inlineDownload].join(' ')}>
      <div className={styles.selectRow}>
        <Select
          className={styles.select}
          aria-label={t('record.import.v2.template.downloadTitle')}
          value={downloadTemplateId}
          onChange={setDownloadTemplateId}
          options={templateCatalog.items.map((item) => ({
            value: item.id,
            label: item.displayName,
          }))}
          loading={templateCatalog.status === 'loading'}
          placeholder={t('record.import.v2.template.selectPlaceholder')}
        />
        <Button onClick={handleDownload} disabled={!downloadTemplate}>
          {t('record.import.v2.template.download')}
        </Button>
      </div>
      <p className={styles.hint}>{t('record.import.v2.template.excelHint')}</p>
    </div>
  )
}

export default TemplateDownloadSection
